import React from 'react';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useLocation } from 'react-use';
import { NextSeo } from 'next-seo';
import Layout from '@/components/Layout';
import JoinUs from '@/components/JoinUs';

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  // Get external data from the file system, API, DB, etc.

  // The value of the `props` key will be
  //  passed to the `Home` component
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'joinus', 'path', 'form'])),
    },
  };
};

const Joinus = () => {
  const { t } = useTranslation(['joinus', 'common']);
  const state = useLocation();
  return (
    <>
      <NextSeo
        openGraph={{
          url: state?.href,
          title: t('common:seo-加入我们-title'),
          description: t('common:seo-加入我们-description'),
          images: [
            {
              url: 'https://cdnwukong.com/images/public/og/offical-site-1.png',
              width: 300,
              height: 300,
              alt: t('common:seo-加入我们-title'),
            },
          ],
        }}
      />
      <Head>
        <title>{t('common:seo-加入我们-title')}</title>
        <meta name="description" content={t('common:seo-加入我们-description')} />
        <meta name="keywords" content={t('common:seo-加入我们-关键词')} />
        <meta
          data-n-head="ssr"
          data-hid="apple-mobile-web-app-title"
          name="apple-mobile-web-app-title"
          content={t('common:seo-加入我们-title')}
        />
      </Head>
      <div className="pt-[110px]">
        <JoinUs />
      </div>
    </>
  );
};

export default Joinus;

Joinus.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;
